import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(contratacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/contratacoes/${contratacaoId}/rateios`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    salvarRateios(contratacaoRateios) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/contratacoes/${contratacaoRateios.codContratacao}/rateios`,
                contratacaoRateios
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
